import './App.css';
import AppRoute from './components/appRouter';


function App() {
  return (
    <div className="App">
       <AppRoute/>
    </div>
  );
}

export default App;
